'use strict';

var withStyles = require('../../../node_modules/@material-ui/core/esm/styles/withStyles.js');
var CardContent$1 = require('../../../node_modules/@material-ui/core/esm/CardContent/CardContent.js');

var styles = function styles() {
  return {
    root: {
      padding: 16,
      '&:last-child': {
        paddingBottom: 16
      }
    }
  };
};
var CardContent = withStyles(styles)(CardContent$1["default"]);

module.exports = CardContent;
